import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder, SerializedData, isSameData } from '../dto/dto.js';
import { PhoneNumber } from './phone-number.js';

export class PhoneContact extends DataModel {
  static readonly TYPE_ID: string = 'd042d63f90eb4cc99ca8f13912506a80';

  constructor(
        public readonly firstName: string | null,
        public readonly lastName: string | null,
        public readonly email: string | null,
        public readonly phoneNumber: PhoneNumber,
  ) {
    super();
  }

  get $typeId(): string {
    return PhoneContact.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PhoneContact {
    return new PhoneContact(
        MapUtils.getOrNull<string>(map, 'firstName'),
        MapUtils.getOrNull<string>(map, 'lastName'),
        MapUtils.getOrNull<string>(map, 'email'),
        PhoneNumber.mustDecode(MapUtils.get<string>(map, 'phoneNumber')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'firstName': this.firstName,
      'lastName': this.lastName,
      'email': this.email,
      'phoneNumber': this.phoneNumber.encode(),
    };
  }

  clone(): this {
    return new PhoneContact(
        this.firstName,
        this.lastName,
        this.email,
        this.phoneNumber.clone(),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.firstName === this.firstName &&
        other.lastName === this.lastName &&
        other.email === this.email &&
        isSameData(other.phoneNumber, this.phoneNumber);
  }
}

export class PhoneContactBuilder extends DataModelBuilder<PhoneContact> {
  build(context: SerializationContext, map: SerializedData): PhoneContact {
    return PhoneContact.fromMap(context, map);
  }
}
